import { render } from "./SharePage.vue?vue&type=template&id=4656fa48&scoped=true"
import script from "./SharePage.vue?vue&type=script&lang=js"
export * from "./SharePage.vue?vue&type=script&lang=js"

import "./SharePage.vue?vue&type=style&index=0&id=4656fa48&scoped=true&lang=css"
import "./SharePage.vue?vue&type=style&index=1&id=4656fa48&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8601aa9edf40feba5c1f16c508af6bdf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4656fa48"]])

export default __exports__